import { render, staticRenderFns } from "./BrandStatistics.vue?vue&type=template&id=3f52593e"
import script from "./BrandStatistics.vue?vue&type=script&lang=js"
export * from "./BrandStatistics.vue?vue&type=script&lang=js"
import style0 from "./BrandStatistics.vue?vue&type=style&index=0&id=3f52593e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports